import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../services/api';
import { Event as BaseEvent, Modalidade } from '../../types';

// Extensão do tipo base com campos exclusivos do admin/organizer
export interface Event extends BaseEvent {
    access_password?: string;
    slug?: string;
    modalidades_json?: string;
    highlights_json?: string;
    agenda_json?: string;
    highlights?: any[];
    agenda?: any[];
    is_registration_open: number;
    is_online_only: number;
    photos_url?: string;
    modalidades?: Modalidade[];
}


export const useEvents = (status?: 'upcoming' | 'past') => {
    return useQuery<Event[]>({
        queryKey: ['events', status],
        queryFn: async () => {
            const { data: eventsList } = await api.get('/events', { params: { status } });
            return eventsList;
        },
    });
};

export const useEventBySlug = (slug?: string) => {
    return useQuery<Event>({
        queryKey: ['event', slug],
        queryFn: async () => {
            const { data: eventDetail } = await api.get(`/events/${slug}`);
            return eventDetail;
        },
        enabled: !!slug
    });
};

export const useSaveEvent = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async (event: Partial<Event>) => {
            if (event.id) {
                return api.put(`/admin/events`, event);
            }
            return api.post(`/admin/events`, event);
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['events'] });
        },
    });
};

export const useDeleteEvent = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async (id: string) => {
            return api.delete('/admin/events', { params: { id } });
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['events'] });
        },
    });
};
